import DeliveryPeriod from "domain/deliveryPeriod";
import { shallowEqual } from "react-redux";
import useLazySelector from "common/redux/useLazySelector";
import { useState } from "react";
import useAjaxCall from "common/ui/useAjaxCall";
import { withCancellationToken } from "common/http/httpService";
import deliveryPeriodService from "./deliveryPeriod.service";
import { DeliveryPeriodActions } from "./deliveryPeriod.actions";


export default function useDeliveryPeriods(commodityId?: number): DeliveryPeriod[] {

    return useLazySelector(
        store => store.deliveryPeriods?.filter(m => commodityId == null || m.commodity.id === commodityId), 
        dispatch => DeliveryPeriodActions.loadDeliveryPeriods()(dispatch),
        null,
        [],
        shallowEqual);
}

export function useDeliveryPeriod(id: string): DeliveryPeriod {
    const [deliveryPeriod, setDeliveryPeriod] = useState<DeliveryPeriod>(null);

    useAjaxCall(cxt => {
        if (id == null) return;
        
        withCancellationToken(deliveryPeriodService, cxt)
            .getDeliveryPeriod(id)
            .then(m => setDeliveryPeriod(m));
    }, [id])

    return deliveryPeriod;
}